import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/plane-fill-darkblue.svg'
import _imports_1 from '@/assets/img/icon/bus-fill-orange.svg'
import _imports_2 from '@/assets/img/icon/bus-fill-green.svg'
import _imports_3 from '@/assets/img/icon/bus-fill-darkblue.svg'
import _imports_4 from '@/assets/img/icon/check-circle-blue.svg'
import _imports_5 from '@/assets/img/icon/arrow-circle-right-outline-blue.svg'
import _imports_6 from '@/assets/img/icon/arrow-circle-left-outline-orange.svg'
import _imports_7 from '@/assets/img/icon/calendar-outline-black.svg'
import _imports_8 from '@/assets/img/icon/user-outline-black.svg'
import _imports_9 from '@/assets/img/icon/steering-wheel-outline-black.svg'
import _imports_10 from '@/assets/img/icon/truck-outline-black.svg'
import _imports_11 from '@/assets/img/icon/check-circle-green.svg'


const _hoisted_1 = { class: "approvepp-list" }
const _hoisted_2 = {
  key: 0,
  class: "content-data-list"
}
const _hoisted_3 = { class: "divide-y divide-solid" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "flex items-center justify-between mb-4 md:mb-0" }
const _hoisted_6 = { class: "md:flex items-center gap-4 w-4/5" }
const _hoisted_7 = { class: "text-xl md:text-2xl font-bold break-words" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center background-custom-light-blue-1 border-custom-dark-blue-1 rounded px-12px py-4px text-xs custom-label"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-3 w-4",
  alt: "edit"
}, null, -1)
const _hoisted_10 = { class: "color-grey-5" }
const _hoisted_11 = {
  key: 1,
  class: "flex items-center background-orange-lighten-3 border-orange rounded px-12px py-4px text-xs custom-label"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-3 w-4",
  alt: "edit"
}, null, -1)
const _hoisted_13 = { class: "color-grey-5" }
const _hoisted_14 = {
  key: 2,
  class: "flex items-center background-custom-light-green-1 border-success rounded px-12px py-4px text-xs custom-label"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mr-3 w-4",
  alt: "edit"
}, null, -1)
const _hoisted_16 = { class: "color-grey-5" }
const _hoisted_17 = {
  key: 3,
  class: "flex items-center background-custom-light-blue-1 border-custom-dark-blue-1 rounded px-12px py-4px text-xs custom-label"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "mr-3 w-4",
  alt: "edit"
}, null, -1)
const _hoisted_19 = { class: "color-grey-5" }
const _hoisted_20 = {
  key: 4,
  class: "flex items-center"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_4,
  style: {"min-width":"17px","height":"17px"},
  alt: ""
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "ml-1 text-primary text-base font-bold" }, "Approved", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "flex items-center justify-start mb-2 md:mb-0" }
const _hoisted_26 = {
  key: 0,
  class: "flex items-center mr-3"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_5,
  style: {"min-width":"17px","height":"17px"},
  alt: ""
}, null, -1)
const _hoisted_28 = { class: "ml-2 text-sm" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_6,
  style: {"min-width":"17px","height":"17px"},
  alt: ""
}, null, -1)
const _hoisted_31 = { class: "ml-2 text-sm" }
const _hoisted_32 = { class: "md:flex items-center justify-between" }
const _hoisted_33 = { class: "md:flex gap-3 mb-2 md:mb-0" }
const _hoisted_34 = { class: "flex items-center pr-3 border-none md:border-solid border-r border-neutral-400 mb-2 md:mb-0" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_7,
  style: {"min-width":"12px","height":"12px"},
  alt: ""
}, null, -1)
const _hoisted_36 = { class: "ml-2 text-xs" }
const _hoisted_37 = { class: "flex items-center gap-4 mb-2 md:mb-0" }
const _hoisted_38 = { class: "flex items-center" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_8,
  style: {"min-width":"12px","height":"12px"},
  alt: ""
}, null, -1)
const _hoisted_40 = { class: "ml-2 text-xs" }
const _hoisted_41 = { class: "flex items-center" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_9,
  style: {"min-width":"12px","height":"12px"},
  alt: ""
}, null, -1)
const _hoisted_43 = { class: "ml-2 text-xs" }
const _hoisted_44 = { class: "flex items-center" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_10,
  style: {"min-width":"12px","height":"12px"},
  alt: ""
}, null, -1)
const _hoisted_46 = { class: "ml-2 text-xs" }
const _hoisted_47 = {
  key: 0,
  class: "text-grey text-sm font-bold"
}
const _hoisted_48 = { class: "flex items-center gap-3" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_11,
  style: {"min-width":"17px","height":"17px"},
  alt: ""
}, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "ml-1 text-green text-base font-bold" }, "Approve", -1)
const _hoisted_53 = {
  key: 1,
  class: "flex items-center cursor-not-allowed"
}
const _hoisted_54 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "ml-1 text-light-green text-base font-bold" }, "Approve", -1)
const _hoisted_56 = {
  key: 0,
  class: "mt-5 pt-5 min-w-[900px] overflow-x-auto"
}
const _hoisted_57 = { class: "w-full table-fixed" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left text-grey pb-3" }, "Rute"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left text-grey pb-3" }, "Kota"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left text-grey pb-3" }, "Tanggal & Waktu"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left text-grey pb-3" }, "Pendapatan Ticket")
  ])
], -1)
const _hoisted_59 = { class: "text-sm font-bold pb-2" }
const _hoisted_60 = { class: "text-sm font-semibold text-grey pb-2" }
const _hoisted_61 = { class: "text-sm font-semibold text-grey pb-2" }
const _hoisted_62 = { class: "text-sm font-semibold pb-2" }
const _hoisted_63 = {
  key: 0,
  class: "text-center text-xs text-grey"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("em", null, "- Kosong -", -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = {
  class: "mt-5 py-5",
  style: {"border-top":"1px solid #EEE"}
}
const _hoisted_67 = { class: "flex justify-between items-center" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Jumlah Setoran", -1)
const _hoisted_69 = { class: "text-primary text-3xl font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApproveDepositHeader = _resolveComponent("ApproveDepositHeader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_Card = _resolveComponent("Card")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_StatusApprovalOptions = _resolveComponent("StatusApprovalOptions")!
  const _component_DateFilterOptions = _resolveComponent("DateFilterOptions")!
  const _component_SearchOptions = _resolveComponent("SearchOptions")!
  const _component_FilterTrayek = _resolveComponent("FilterTrayek")!
  const _component_FilterClass = _resolveComponent("FilterClass")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_ApproveModal = _resolveComponent("ApproveModal")!
  const _component_HjpConfirmationModal = _resolveComponent("HjpConfirmationModal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-list" }, {
      title: _withCtx(() => [
        _createVNode(_component_ApproveDepositHeader, {
          onShowDropDown: _ctx.showDropDown,
          onOnSearch: _ctx.onSearch,
          selectedStatusId: _ctx.selectedStatus,
          selectedClass: _ctx.selectedClassSearchLabel,
          selectedTrayek: _ctx.selectedTrayekSearchLabel
        }, null, 8, ["onShowDropDown", "onOnSearch", "selectedStatusId", "selectedClass", "selectedTrayek"])
      ]),
      content: _withCtx(() => [
        (_ctx.dataSource.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource, (data, id) => {
                return (_openBlock(), _createBlock(_component_Card, {
                  class: "card-no-shadow mb-4",
                  key: id
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(data.TrxId), 1),
                            (data.RosterStatusCode === 'AIR')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _hoisted_9,
                                  _createElementVNode("span", _hoisted_10, _toDisplayString(data.RosterStatusName), 1)
                                ]))
                              : (data.RosterStatusCode === 'PRW')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _hoisted_12,
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(data.RosterStatusName), 1)
                                  ]))
                                : (data.RosterStatusCode === 'GBG')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _hoisted_15,
                                      _createElementVNode("span", _hoisted_16, _toDisplayString(data.RosterStatusName), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _hoisted_18,
                                      _createElementVNode("span", _hoisted_19, _toDisplayString(data.RosterStatusName), 1)
                                    ])),
                            (data.IsApproved)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("span", null, [
                              _createElementVNode("i", {
                                class: _normalizeClass(_ctx.showDetailId === data.Id ? 'pi pi-angle-right text-2xl font-medium cursor-pointer' : 'pi pi-angle-down text-2xl font-medium cursor-pointer'),
                                onClick: ($event: any) => (_ctx.openDetail(data.Id))
                              }, null, 10, _hoisted_24)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          (data.Rits.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _hoisted_27,
                                _createElementVNode("div", _hoisted_28, _toDisplayString(`${data.Rits[0] ? data.Rits[0].RouteName : 'Tidak memiliki rute'}`), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("div", _hoisted_31, _toDisplayString(`${data.Rits.length > 1 ? data.Rits[data.Rits.length - 1].RouteName : 'Tidak memiliki rute'}`), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _hoisted_35,
                                _createElementVNode("div", _hoisted_36, _toDisplayString(`${data.RosterCode ?? ''}
                                                    (${_ctx.moment(data.RosterDate.toString()).format('DD MMMM YYYY')})`), 1)
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _hoisted_39,
                                  _createElementVNode("div", _hoisted_40, _toDisplayString(data.HelperName ?? '-'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _hoisted_42,
                                  _createElementVNode("div", _hoisted_43, _toDisplayString(data.DriverName ?? '-'), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_44, [
                                _hoisted_45,
                                _createElementVNode("div", _hoisted_46, _toDisplayString(data.VehicleRegNumber ?? '-'), 1)
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              (data.RosterStatusRemark)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(`Keterangan Roster : ${data.RosterStatusRemark ?? '-'}`), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            (data.Rits.length > 0)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "text-primary text-base font-bold cursor-pointer",
                                  onClick: ($event: any) => (_ctx.showDetailPage(data.Id))
                                }, "Lihat Detail", 8, _hoisted_49))
                              : _createCommentVNode("", true),
                            (_ctx.checkProhibitedRoles(['Roster']))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                  (!data.IsApproved && data.IsCanApprove)
                                    ? (_openBlock(), _createBlock(_component_Button, {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.approveAct(data.Id)),
                                        class: "flex items-center btn-success-outline"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_51,
                                          _hoisted_52
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                        (!data.IsApproved && !data.IsCanApprove)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                              _createVNode(_component_Popper, {
                                                arrow: "",
                                                hover: "",
                                                placement: "left",
                                                content: _ctx.tooltipText
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_55
                                                ]),
                                                _: 1
                                              }, 8, ["content"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      (_ctx.showDetailId === data.Id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _createElementVNode("table", _hoisted_57, [
                              _hoisted_58,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.Rits, (items) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    class: "pb-3",
                                    key: items
                                  }, [
                                    _createElementVNode("td", _hoisted_59, _toDisplayString(items.RouteName), 1),
                                    _createElementVNode("td", _hoisted_60, _toDisplayString(`${items.FirstTerminal} -
                                                  ${items.LastTerminal}`), 1),
                                    _createElementVNode("td", _hoisted_61, _toDisplayString(`${_ctx.moment(items.StartDate.toString()).format('DD MMMM YYYY')} at
                                                  ${_ctx.moment(items.StartDate.toString()).format('HH.mm')}`), 1),
                                    _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.currencyNumberFormat(items.TotalTicketAmount)), 1)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            (data.Rits.length === 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_63, _hoisted_65))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _hoisted_68,
                                _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.currencyNumberFormat(data.TotalTicketPpAmount)), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          : (_ctx.dataSource.length === 0)
            ? (_openBlock(), _createBlock(_component_EmptyState, {
                key: 1,
                textNoData: "Data tidak tersedia."
              }))
            : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        (_ctx.paginate.totalRecords > 0)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 0,
              rows: _ctx.paginate.pageSize,
              totalRecords: _ctx.paginate.totalRecords,
              onOnPage: _ctx.onChangePage
            }, null, 8, ["rows", "totalRecords", "onOnPage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        (_ctx.selection === 0)
          ? (_openBlock(), _createBlock(_component_StatusApprovalOptions, {
              key: 0,
              selected: _ctx.selectedStatus,
              onSelectStatusApproval: _ctx.selectStatusApproval
            }, null, 8, ["selected", "onSelectStatusApproval"]))
          : _createCommentVNode("", true),
        (_ctx.selection === 1)
          ? (_openBlock(), _createBlock(_component_DateFilterOptions, {
              key: 1,
              rangeDate: _ctx.rangeDate,
              onOnFilterDateRange: _ctx.onFilterDateRange
            }, null, 8, ["rangeDate", "onOnFilterDateRange"]))
          : _createCommentVNode("", true),
        (_ctx.selection === 2)
          ? (_openBlock(), _createBlock(_component_SearchOptions, {
              key: 2,
              selected: _ctx.selectedSearch.val,
              onSelectSearchOption: _ctx.selectSearchOption
            }, null, 8, ["selected", "onSelectSearchOption"]))
          : _createCommentVNode("", true),
        (_ctx.selection === 3)
          ? (_openBlock(), _createBlock(_component_FilterTrayek, {
              key: 3,
              selected: _ctx.selectedTrayekSearch,
              onSelectSearchOption: _ctx.selectSearchTrayekOption
            }, null, 8, ["selected", "onSelectSearchOption"]))
          : _createCommentVNode("", true),
        (_ctx.selection === 4)
          ? (_openBlock(), _createBlock(_component_FilterClass, {
              key: 4,
              selected: _ctx.selectedClassSearch,
              onSelectSearchOption: _ctx.selectSearchClassOption
            }, null, 8, ["selected", "onSelectSearchOption"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    (_ctx.isShowApproveDialog)
      ? (_openBlock(), _createBlock(_component_ApproveModal, {
          key: 0,
          id: _ctx.selectedId,
          show: _ctx.isShowApproveDialog,
          onHideApproveDialog: _ctx.hideApproveDialog,
          onSubmit: _ctx.onSubmitConfirmation
        }, null, 8, ["id", "show", "onHideApproveDialog", "onSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_HjpConfirmationModal, {
      show: _ctx.attrModalConfirmation.show,
      imgContent: _ctx.attrModalConfirmation.imgContent,
      title: _ctx.attrModalConfirmation.title,
      subTitle: _ctx.attrModalConfirmation.subTitle,
      btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
      onHideDialog: _ctx.hideDialogConfirmation,
      onOnSubmit: _ctx.onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
  ]))
}